import script from "./invitationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./invitationView.vue?vue&type=script&setup=true&lang=ts"

import "./invitationView.vue?vue&type=style&index=0&id=281614cd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-281614cd"]])

export default __exports__